/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecReviewSRExtScanResult } from './SecReviewSRExtScanResult';
import {
    SecReviewSRExtScanResultFromJSON,
    SecReviewSRExtScanResultFromJSONTyped,
    SecReviewSRExtScanResultToJSON,
} from './SecReviewSRExtScanResult';

/**
 * 
 * @export
 * @interface SecReviewSRExtScanPagedResponse
 */
export interface SecReviewSRExtScanPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRExtScanPagedResponse
     */
    total: number;
    /**
     * 
     * @type {Array<SecReviewSRExtScanResult>}
     * @memberof SecReviewSRExtScanPagedResponse
     */
    results: Array<SecReviewSRExtScanResult>;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRExtScanPagedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRExtScanPagedResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the SecReviewSRExtScanPagedResponse interface.
 */
export function instanceOfSecReviewSRExtScanPagedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function SecReviewSRExtScanPagedResponseFromJSON(json: any): SecReviewSRExtScanPagedResponse {
    return SecReviewSRExtScanPagedResponseFromJSONTyped(json, false);
}

export function SecReviewSRExtScanPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSRExtScanPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(SecReviewSRExtScanResultFromJSON)),
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function SecReviewSRExtScanPagedResponseToJSON(value?: SecReviewSRExtScanPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(SecReviewSRExtScanResultToJSON)),
        'page': value.page,
        'page_size': value.page_size,
    };
}

